import React from "react";
import { Row, Col } from "react-bootstrap";

import OptionCard from "../../option-card";
import { deepEqual } from "../../../utils/object";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta.default,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }    
    
    componentDidUpdate(oldProps) {
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? {};
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }
    
    onChange = (e) => {
        const newValue = e.target.value;
        if (this.state.data === newValue) return;
        
        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        return (<>
            {this.state.label ?
                <Row className="g-3">
                    <Col lg="12">
                        <h2 className="small-title">{this.state.label}</h2>
                    </Col>
                </Row>
                : ``}
            <Row className="g-3 mb-3">
                {this.state.configuration.options?.map(item => (
                    <>
                        <Col xs="3">
                            <OptionCard name={this.props.element} value={item.value} checked={this.state.data === item.value} onChange={this.state.locked ? null : this.onChange} iconClassName={item.icon} iconClassColor={item.color} iconFontSize="48px" caption={ item.caption } />
                        </Col>
                    </>
                ))}
            </Row>
        </>)
    }
}

export default Name;